export function saveInSessionStorage<T = any>(key: string, value: T): void {
    sessionStorage.setItem(key, JSON.stringify(value));
}
